import { render, staticRenderFns } from "./diamond-dialog.vue?vue&type=template&id=e2e0d4a6&scoped=true&"
import script from "./diamond-dialog.vue?vue&type=script&lang=js&"
export * from "./diamond-dialog.vue?vue&type=script&lang=js&"
import style0 from "./diamond-dialog.vue?vue&type=style&index=0&id=e2e0d4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e0d4a6",
  null
  
)

export default component.exports